import {
  OnInit,
  Input,
  Directive,
  ElementRef,
  NgZone,
  OnDestroy,
} from '@angular/core';

@Directive({
  selector: '[adTooltip]',
})
export class AdTooltipDirective implements OnInit, OnDestroy {
  @Input('adTooltip') text: string;
  setT: any;
  @Input() align: 'bottom' | 'left' | 'top' | 'right' = 'bottom';
  delay: number = 300; //ms
  @Input() gap: number = 10;
  container: any;
  tooltipText: any;
  mouseEnterListener: any;
  mouseLeaveListener: any;
  @Input()
  popupClass: string = '';
  constructor(public el: ElementRef, public ngZone: NgZone) {}

  ngOnInit() {
    this.mouseEnterListener = this.onMouseEnter.bind(this);
    this.mouseLeaveListener = this.onMouseLeave.bind(this);
    this.ngZone.runOutsideAngular(() => {
      this.el.nativeElement.addEventListener(
        'mouseenter',
        this.mouseEnterListener
      );
      this.el.nativeElement.addEventListener(
        'mouseleave',
        this.mouseLeaveListener
      );
    });
  }

  ngOnDestroy(): void {
    this.unbindEvent();
    //Bug 16928:QA bug: tooltip in Document tab leave in Overview tab when switch from Document to Overview tab
    this.removeDom();
    clearTimeout(this.setT);
  }

  onMouseEnter(e: Event) {
    if (this.text) {
      this.removeDom();
      if (!this.container) {
        clearTimeout(this.setT);
        this.setT = setTimeout(() => {
          this.show();
        }, this.delay);
      }
    }
  }

  onMouseLeave(e: Event) {
    clearTimeout(this.setT);
    this.setT = setTimeout(() => {
      this.removeDom();
    }, this.delay);
  }

  show() {
    this.createDom();
    switch (this.align) {
      case 'bottom':
        this.alignBottom();
        break;
      case 'left':
        this.alignLeft();
        break;
      case 'right':
        this.alignRight();
        break;
      case 'top':
        this.alignTop();
        break;
    }
  }

  removeDom() {
    if (this.container && this.container.parentElement) {
      document.body.removeChild(this.container);
    }

    this.container = null;
  }

  unbindEvent() {
    this.el.nativeElement.removeEventListener(
      'mouseenter',
      this.mouseEnterListener
    );
    this.el.nativeElement.removeEventListener(
      'mouseleave',
      this.mouseLeaveListener
    );
  }

  getHostOffset() {
    let offset = this.el.nativeElement.getBoundingClientRect();
    let targetLeft = offset.left + this.getWindowScrollLeft();
    let targetTop = offset.top + this.getWindowScrollTop();
    return { left: targetLeft, top: targetTop };
  }

  alignBottom() {
    let hostOffset = this.getHostOffset();
    let left =
      hostOffset.left +
      (this.getOuterWidth(this.el.nativeElement) -
        this.getOuterWidth(this.container)) /
        2;
    let top =
      hostOffset.top + this.gap + this.getOuterHeight(this.el.nativeElement);
    this.container.style.left = left + 'px';
    this.container.style.top = top + 'px';
  }

  alignTop() {
    let hostOffset = this.getHostOffset();
    let left =
      hostOffset.left +
      (this.getOuterWidth(this.el.nativeElement) -
        this.getOuterWidth(this.container)) /
        2;
    let top = hostOffset.top - this.gap - this.getOuterHeight(this.container);
    this.container.style.left = left + 'px';
    this.container.style.top = top + 'px';
  }

  alignLeft() {
    let hostOffset = this.getHostOffset();
    let left = hostOffset.left - this.gap - this.getOuterWidth(this.container);
    let top =
      hostOffset.top +
      (this.getOuterHeight(this.el.nativeElement) -
        this.getOuterHeight(this.container)) /
        2;
    this.container.style.left = left + 'px';
    this.container.style.top = top + 'px';
  }

  alignRight() {
    let hostOffset = this.getHostOffset();
    let left =
      hostOffset.left + this.gap + this.getOuterWidth(this.el.nativeElement);
    let top =
      hostOffset.top +
      (this.getOuterHeight(this.el.nativeElement) -
        this.getOuterHeight(this.container)) /
        2;
    this.container.style.left = left + 'px';
    this.container.style.top = top + 'px';
  }

  getWindowScrollTop(): number {
    let doc = document.documentElement;
    return (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
  }

  getWindowScrollLeft(): number {
    let doc = document.documentElement;
    return (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
  }

  getOuterWidth(el, margin?) {
    let width = el.offsetWidth;
    if (margin) {
      let style = getComputedStyle(el);
      width += parseFloat(style.marginLeft) + parseFloat(style.marginRight);
    }
    return width;
  }

  getOuterHeight(el, margin?) {
    let height = el.offsetHeight;

    if (margin) {
      let style = getComputedStyle(el);
      height += parseFloat(style.marginTop) + parseFloat(style.marginBottom);
    }

    return height;
  }

  createDom() {
    this.container = document.createElement('div');

    // let tooltipArrow = document.createElement('div');
    // tooltipArrow.className = 'p-tooltip-arrow';
    // this.container.appendChild(tooltipArrow);

    this.tooltipText = document.createElement('div');
    this.tooltipText.className = 'ad-tooltip-text ' + this.popupClass;
    this.tooltipText.innerHTML = this.text;
    this.container.appendChild(this.tooltipText);
    document.body.appendChild(this.container);

    this.container.className = 'ad-tooltip-container';
  }
}
